import * as React from "react";
import FirebaseApi from "../../../api/firebase/FirebaseApi";

const FirebaseApiContext = React.createContext<FirebaseApi | null>(null);
export default FirebaseApiContext;
